import { updateSession } from '../../../lib/funnels/functions/v1/default/updateSession.js'
import { getFunnelCache } from '../../../lib/funnels/functions/v1/default/getFunnelCache.js'
import { queryParamsToSession } from '../../../lib/funnels/functions/v1/default/queryParamsToSession.js'
import { STATES } from '../../../lib/funnels/constants/states.js'

const SESSION_ID = 'atdsFunnel'
// funnel is served from the domain root in prod, but under /atds locally
const BASE_PATH = window.location.hostname.includes('local') ? '/atds' : ''

document.addEventListener('DOMContentLoaded', () => {
  queryParamsToSession(SESSION_ID)

  const sessData = getFunnelCache(SESSION_ID) || {}

  if (sessData.df == 1) {
    document.getElementById('headline').innerHTML =
      'You could be one of <b>thousands of Americans</b> who benefit from our program every month!'
  }

  const stateSelect = /** @type {HTMLSelectElement} */ (
    document.getElementById('s')
  )
  STATES.forEach((state) => {
    const opt = document.createElement('option')
    opt.value = state.abbreviation
    opt.textContent = state.name
    stateSelect.appendChild(opt)
  })
  if (sessData.region) stateSelect.value = sessData.region

  const form = document.getElementById('state-form')
  form?.addEventListener('submit', (e) => {
    e.preventDefault()
    const state = stateSelect.value
    updateSession(SESSION_ID, 'state', state)
    window.location.href = `${BASE_PATH}/4/${window.location.search}`
  })
})
